import { useEffect, useState } from 'react';
import { DefaultProductFilters } from '@/components/search/instantSearch/DefaultProductFilters';
import { Button } from '@fagmobler/ui';

import { CurrentRefinements } from '@/components/search/instantSearch/CurrentRefinements';
import { ClearRefinements } from '@/components/search/instantSearch/ClearRefinements';
import SortingButtonWithPopover from '@/components/search/SortingButtonWithPopover';
import {
  AdjustmentsVerticalIcon,
  MagnifyingGlassIcon,
} from '@heroicons/react/20/solid';
import { excludedRefinementAttributes } from '../Search';
import { SearchBox, useStats } from 'react-instantsearch-hooks-web';

export const ProductCategoryListHeader = ({
  placeholder,
}: {
  placeholder?: string;
}) => {
  const { nbHits } = useStats();
  const [showFilters, setShowFilters] = useState(false);

  return (
    <div>
      <div className="flex items-stretch flex-col sm:flex-row sm:space-x-2 mb-3">
        <div className="flex-grow">
          <SearchBox
            placeholder={placeholder || 'Filter produkter'}
            submitIconComponent={() => (
              <MagnifyingGlassIcon className="shrink-0 w-4 h-4" />
            )}
            classNames={{
              form: 'flex p-2 bg-neutral-30 rounded focus-within:ring',
              input: 'bg-neutral-30 px-2 w-full text-sm outline-none ',
              submit: '-order-1',
            }}
          />
        </div>
        <div className="pt-3 sm:pt-0 flex space-x-2">
          <SortingButtonWithPopover />

          <Button
            className="whitespace-nowrap block pr-3 w-full justify-center"
            type="button"
            onClick={() => setShowFilters(true)}
          >
            <AdjustmentsVerticalIcon className="h-4 w-4 mr-2" />
            Vis filter{' '}
          </Button>
        </div>
      </div>

      <div className="flex items-baseline mb-4">
        <div className="mr-2">{nbHits} produkter</div>
        {/* <ClearRefinements excludedAttributes={excludedRefinementAttributes} /> */}
      </div>

      {/* <CurrentRefinements excludedAttributes={excludedRefinementAttributes} /> */}

      <DefaultProductFilters
        isOpen={showFilters}
        onClose={() => setShowFilters(false)}
      />
    </div>
  );
};

export default ProductCategoryListHeader;
